import { SimpleGrid } from "@mantine/core";
import { PropertyComposite } from "grapesjs";

import { CustomStylePropertyField } from "../style-manager/CustomStylePropertyField";

export const CompositePropertyFields = (props: {
  property: PropertyComposite;
}) => {
  const { property } = props;

  return (
    <SimpleGrid
      cols={2}
      p={"xs"}
      sx={{
        // border: "1px solid transparent",
        borderRadius: 12,
        background: "var(--mantine-color-gray-1)",
        border: "1px solid var(--mantine-color-gray-3)",
      }}
    >
      {property.getProperties().map((prop) => (
        <CustomStylePropertyField key={prop.getId()} prop={prop} />
      ))}
    </SimpleGrid>
  );
};
